"use client";

import dynamic from "next/dynamic";

import type { A11yControlsProps } from "components/A11yControls/types";
import { cn } from "utils/helpers/cn";

const A11yDropdownMenu = dynamic(() => import("components/A11yControls/A11yDropdownMenu"));
const A11yMenu = dynamic(() => import("components/A11yControls/A11yMenu"));

function A11yControlsClientSide({ variant, className }: A11yControlsProps) {
    return (
        <div className={cn("self-end", className)}>
            <div className="md:hidden">
                <A11yDropdownMenu variant={variant} />
            </div>
            <div className="hidden md:block">
                <A11yMenu variant={variant} />
            </div>
        </div>
    );
}

export default A11yControlsClientSide;
